import axios from "axios";

import URL from "../config/api";

export const profileUpdate = (
  user,
  userComplement,
  callback = () => null,
  parents = undefined
) => {
  const obj = { ...user, complement: userComplement, parent: parents };

  return (dispatch, getState) => {
    axios
      .post(`${URL.api}access/user/update/${user.id}`, obj, {
        headers: { authorization: `Bearer ${getState().user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          callback();
        }
      });
  };
};
export const profileGet =
  (id, token, callback = () => null) =>
  (dispatch, getState) => {
    if (id) {
      axios
        .get(`${URL.api}access/user/singleView/${id}`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            const user = resp.data.data;
            dispatch({ type: "GET_PROFILE", payload: user });
            callback(user);
          }
        });
    }
  };
export const profileCreate = (user, token) => (dispatch, getState) => {
  axios
    .post(`${URL.api}access/user/insert`, user, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(resp => {
      // if(resp.data.success){
      //     const user = resp.data.data
      //     return (dispatch({type: 'GET_PROFILE', payload: user}))
      // }
    });
};
export const clearProfile = (id, token) => (dispatch, getState) =>
  dispatch({ type: "GET_PROFILE", payload: "" });
